import React, { createContext, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";
import JoinFullIcon from "@mui/icons-material/JoinFull";
import { TextField } from "@mui/material";
import { useHistory } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CallIcon from '@mui/icons-material/Call';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { color } from "echarts";
import { FormatMoney } from "../../../Helpers/FormatNumber";
// import FiltroClientesGestionar from "../Components/FiltroClientesGestionar";
// import { useBox } from "../../ReporteCobranza/Helper/useBox";
// import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";

export const ContextConvenio = createContext();
export const ListadoClientesJuridicoScreen = () => {
    const history = useHistory();
    const [selected, setSelected] = useState([]);
    const [predictivo, setPredictivo] = useState("");
    const [clientes, setClientes] = useState([]);
    const [arrayClientes, setArrayClientes] = useState([]);
    // const [boxstate, setBoxState] = useBox();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ClientesJuridico/ClientesJuridico`)
            .then((result) => {
                setClientes(result);
                setArrayClientes(result);
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    }, []);

    // console.log(clientes)

    // const onExecute = (responsable, linea, cartera, convenio, juridico) => {
    //     // console.log(convenio)
    //     var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    //     var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    //     if (sucursales === undefined || sucursales === null || sucursales === "") {
    //         sucursales = "0";
    //     }
    //     if (adr === undefined || adr === null || adr === "") {
    //         adr = "0";
    //     }
    //     // console.log(adr, sucursales)
    //     return new Promise((resolve, reject) => {
    //         setLoader({ ...loader, mostrar: true });
    //         request
    //             .get(
    //                 `ListadoClientesGestionarPrueba/ListadoClientes?responsable=${responsable}&sucursal=${sucursales}&adr=${adr}&linea=${linea}&cartera=${cartera}&convenio=${convenio}&juridico=${juridico}`
    //             )
    //             .then((result) => {
    //                 setLoader({ ...loader, mostrar: false });
    //                 setClientes(result);
    //                 setArrayClientes(result);
    //                 return;
    //             })
    //             .catch((error) => {
    //                 setLoader({ ...loader, mostrar: false });
    //                 reject(error);
    //                 return;
    //             });
    //     });
    // };

    useEffect(() => {
        const result = arrayClientes.filter((item) =>
            item.razon_social.toUpperCase().includes(predictivo.toUpperCase())
        );
        setSelected([]);
        setClientes(result);
    }, [predictivo]);

    const onRegistrar = (idcliente, razonsocial) => {
        history.push("/Creditoycobranza/RegistrarCliente", {
            idcliente,
            razonsocial,
        });
    };
    const onConvenio = (idcliente, razonsocial, responsable, idregistro) => {

        if (idcliente.toString().length <= 6) {
            history.push("/Credito/DetalleJuridico", {
                idcliente,
                razonsocial,
                responsable,
                idregistro
            });
        } else {
            Swal.fire("CREDITO Y COBRANZA", "El cliente no se encuentra registrado", "error");
        }
    };
    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // const onGeneraExcel = (responsable, linea, cartera, convenio, juridico) => {
    //     var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    //     var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    //     if (sucursales === undefined || sucursales === null || sucursales === "") {
    //         sucursales = "0";
    //     }
    //     if (adr === undefined || adr === null || adr === "") {
    //         adr = "0";
    //     }
    //     setLoader({ ...loader, mostrar: true });
    //     request
    //         .get(`ListadoClientesGestionarPrueba/ImprimirExcel?responsable=${responsable}&sucursal=${sucursales}&adr=${adr}&linea=${linea}&cartera=${cartera}&convenio=${convenio}&juridico=${juridico}`)
    //         .then(({ documento, filename }) => {
    //             const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
    //             const downloadLink = document.createElement("a");
    //             const fileName = `${filename}.xlsx`;
    //             downloadLink.href = linkSource;
    //             downloadLink.download = fileName;
    //             downloadLink.click();
    //             setLoader({ ...loader, mostrar: false });
    //         })
    //         .catch((error) => {
    //             setLoader({ ...loader, mostrar: false });
    //             Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
    //         });
    // };
    // console.log(boxstate)

    // const onGeneraPDF = (responsable, linea, cartera, convenio, juridico) => {
    //     var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    //     var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    //     if (sucursales === undefined || sucursales === null || sucursales === "") {
    //         sucursales = "0";
    //     }
    //     if (adr === undefined || adr === null || adr === "") {
    //         adr = "0";
    //     }
    //     setLoader({ ...loader, mostrar: true });
    //     request
    //         .get(`ListadoClientesGestionarPrueba/ImprimirPDF?responsable=${responsable}&sucursal=${sucursales}&adr=${adr}&linea=${linea}&cartera=${cartera}&convenio=${convenio}&juridico=${juridico}`)
    //         .then((result) => {
    //             setLoader({ ...loader, mostrar: false });
    //             const linkSource = `data:application/pdf;base64, ${result.documento}`;
    //             const downloadLink = document.createElement("a");
    //             const fileName = `${result.nombredocumento}.${result.extension}`;
    //             downloadLink.href = linkSource;
    //             downloadLink.download = fileName;
    //             downloadLink.click();
    //         })
    //         .catch((error) => {
    //             setLoader({ ...loader, mostrar: false });
    //             Swal.fire("Clientes", JSON.stringify(error), "error");
    //         });
    // };
    // console.log(clientes)
    return (
        <PlantillaScreen
            titulo={"SELECCIONAR CLIENTE"}
            className={"listado-clientes-juridico-main-screen"}
            className_main={1}
        >
            <div className="listado-clientes-juridico-actions">
                <div
                    className="listado-clientes-juridico-actions-regresar"
                    onClick={() => history.push('/Credito/Main')}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="listado-clientes-juridico-actions-filtro">
                    {/* <FiltroClientesGestionar
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                    /> */}
                </div>
                <div className="buttons">
                    <button className="excel"
                    // onClick={() => onGeneraExcel(boxstate.responsable, boxstate.linea, boxstate.cartera, boxstate.convenio, boxstate.juridico)}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button className="PDF"
                        // onClick={() =>
                        //     onGeneraPDF(boxstate.responsable, boxstate.linea, boxstate.cartera, boxstate.convenio, boxstate.juridico)
                        // }
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button>
                </div>
            </div>
            <div className="contador-clientes-encontrados">
                Clientes Encontrados: {clientes.length}
            </div>
            <LoaderScreen loader={loader} />
            <div className="listado-clientes-juridico-screen">
                <div className="listado-clientes-juridico-header">
                    <div className="listado-clientes-juridico-header-control">
                        <TextField
                            color="success"
                            fullWidth
                            size="small"
                            value={predictivo}
                            onChange={({ target }) => setPredictivo(target.value)}
                            placeholder="Buscar Clientes..."
                        />
                    </div>
                </div>
                <div className="listado-clientes-juridico-container scroll-4">
                    {clientes !== undefined &&
                        clientes !== null &&
                        clientes.length > 0 ? (
                        <table cellSpacing={0} cellPadding={0}>
                            <thead>
                                <tr>
                                    {/* <th>
                                        ID Cliente
                                    </th>
                                    <th className="razon-social-celda">
                                        <div>Razón Social</div>
                                    </th>
                                    <th>
                                        <div>Creación Convenio</div>
                                    </th>
                                    <th>
                                        <div>Usuario</div>
                                    </th>
                                    <th>
                                        <div>Importe</div>
                                    </th>
                                    <th>
                                        <div>Convenio</div>
                                    </th>
                                    <th>
                                        <div>Saldo</div>
                                    </th>
                                    <th>
                                        <div>Interes</div>
                                    </th>
                                    <th>
                                        <div>RFC</div>
                                    </th>
                                    <th>
                                        <div>Factura Vencida</div>
                                    </th> */}
                                    <th className="razon-social-celda">
                                        Cliente
                                    </th>
                                    <th className="rfc-celda">
                                        <div>RFC</div>
                                    </th>
                                    <th>
                                        <div>Importe Vencido</div>
                                    </th>
                                    <th>
                                        <div>Dias Vencido</div>
                                    </th>
                                    <th>
                                        <div>Fecha de Inicio Jurídico</div>
                                    </th>
                                    <th>
                                        <div>Domicilio</div>
                                    </th>
                                    <th>
                                        <div>Teléfono</div>
                                    </th>
                                    <th>
                                        <div>Estado Cliente</div>
                                    </th>
                                    <th>
                                        <div>No. Expediente</div>
                                    </th>
                                    <th>
                                        <div>Juzgado</div>
                                    </th>
                                    <th>
                                        <div>Estado Demanda</div>
                                    </th>
                                    {/* <th>
                                        <div style={{ color: 'transparent' }}>d</div>
                                    </th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {clientes.map((ctl) => (
                                    <tr
                                        onClick={() =>
                                            onConvenio(ctl.idcliente, ctl.razon_social, ctl.idResponsableCobranza, ctl.idregistro)
                                        }
                                    >
                                        <td className="razon-social-celda">{ctl.razon_social}</td>
                                        <td className="rfc-celda">{ctl.rfc}</td>
                                        <td className="saldo-celda">{FormatMoney(ctl.importe_total_vencido, 0)}</td>
                                        <td className="convenio-celda">{ctl.dias_vencido}</td>
                                        <td className="fecha-celda">{ctl.fecha_juridico}</td>
                                        <td className="razon-social-celda">{ctl.domicilio}</td>
                                        <td className="fecha-celda">{ctl.telefono}</td>
                                        <td className="fecha-celda">{ctl.estatus_cliente || '-'}</td>
                                        <td className="convenio-celda">{ctl.num_expediente && ctl.num_expediente !== 0 ? ctl.num_expediente : '-'}</td>
                                        <td className="objecion-celda">{ctl.nombre_juzgado || '-'}</td>
                                        <td className="objecion-celda">{ctl.estatus_demanda || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div>Sin Datos</div>
                    )}
                    <div>
                        <table></table>
                    </div>
                </div>
            </div>
        </PlantillaScreen>
    );
};
